import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _pickBy from "lodash/pickBy";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { RESET_PLAID_ONBOARDING, getPortalForInstitution, initializePortal } from "../actions/financial-data";
import { deleteProviderAccount, startYodleeOnboarding } from "../actions/yodlee";
var initialState = {
  portalsByInstitutionId: {},
  selectedPortalId: null
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case getPortalForInstitution.SUCCESS_TYPE:
      {
        var payload = action.payload;

        var portal = _get(payload, 'data.financialPortalByInstitutionId');

        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _objectSpread(_objectSpread({}, state.portalsByInstitutionId), {}, _defineProperty({}, portal.marketplaceInstitution.id, portal))
        });
      }

    case initializePortal.SUCCESS_TYPE:
      {
        var _payload = action.payload;

        var institution = _get(_payload, 'data.initializeFinancialPortal');

        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _objectSpread(_objectSpread({}, state.portalsByInstitutionId), {}, _defineProperty({}, institution.marketplaceInstitution.id, institution))
        });
      }

    case RESET_PLAID_ONBOARDING:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedPortalId: null
      });

    case deleteProviderAccount.SUCCESS_TYPE:
      {
        var _payload2 = action.payload; // If a user unlinks a portal, clear the portal cache

        return _objectSpread(_objectSpread({}, state), {}, {
          portalsByInstitutionId: _pickBy(state.portalsByInstitutionId, function (portal) {
            return portal.id !== _payload2.deletedPortalId;
          })
        });
      }

    case startYodleeOnboarding.getType():
      {
        var _payload3 = action.payload;

        if (_payload3.providerId) {
          return _objectSpread(_objectSpread({}, state), {}, {
            selectedPortalId: _payload3.providerId
          });
        }

        return state;
      }

    default:
      return state;
  }
});